// extracted by mini-css-extract-plugin
export var brand = "_8i-9";
export var compact = "_8i-6";
export var extraSmall = "_8i-7";
export var icon = "_8i-0";
export var large = "_8i-4";
export var light = "_8i-1";
export var medium = "_8i-5";
export var outline = "_8i-b";
export var primaryDark = "_8i-a";
export var primaryLight = "_8i-8";
export var primaryModern = "_8i-c";
export var success = "_8i-2";
export var successSolid = "_8i-3";